import React from "react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { useT } from "@/context/LanguageContext";
import { Star, Quotes } from "@phosphor-icons/react";

function TestimonialCard({ tm, index }) {
  return (
    <figure
      data-testid={`testimonial-${index}`}
      className="w-[380px] shrink-0 rounded-xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-teal/50 hover:shadow-lg"
    >
      <div className="flex items-center justify-between">
        <Quotes size={30} weight="fill" className="text-teal/30" />
        <div className="flex gap-0.5">
          {Array.from({ length: tm.rating || 5 }).map((_, k) => (
            <Star key={`star-${k}`} size={15} weight="fill" className="text-[#F5B544]" />
          ))}
        </div>
      </div>
      <blockquote className="mt-4 text-[15px] leading-relaxed text-slate-700 line-clamp-4">"{tm.quote}"</blockquote>
      <figcaption className="mt-5 flex items-center gap-3 border-t border-slate-100 pt-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#1E73BE] to-[#16B894] font-heading text-sm font-bold text-white">
          {tm.name.charAt(0)}
        </div>
        <div>
          <p className="font-heading text-sm font-semibold text-ink">{tm.name}</p>
          <p className="text-xs text-slate-500">{tm.role} · {tm.country}</p>
        </div>
      </figcaption>
    </figure>
  );
}

export function Testimonials({ testimonials = [] }) {
  const { t } = useT();
  if (!testimonials.length) return null;
  const items = [...testimonials, ...testimonials];

  return (
    <section className="overflow-hidden bg-white py-24 lg:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          overline={t("testimonials.overline")}
          title={t("testimonials.title")}
          subtitle={t("testimonials.subtitle")}
          align="center"
        />
      </div>
      <div className="group relative mt-14">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent" />
        <div
          className="flex w-max animate-marquee items-stretch gap-6 px-5 group-hover:[animation-play-state:paused]"
          style={{ animationDuration: "45s" }}
          data-testid="testimonials-marquee"
        >
          {items.map((tm, i) => (
            <TestimonialCard key={`${tm.name}-${Math.floor(i / testimonials.length)}`} tm={tm} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
